import {Routes} from '@angular/router';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {PERMISSION} from '@generated-backend-types';
import {IndexComponent as DocumentIndexComponent} from './index/index.component';

export const routes: Routes = [
  {
    path: '',
    component: DocumentIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [
        PERMISSION.QUALITYMANAGEMENT_PROCESS_READ_ALL,
        PERMISSION.PRIVATEATTACHMENT_READ_ALL,
      ],
      breadcrumb: [
        {
          label: 'authenticated.quality-management.documents.index.breadcrumb',
          translate: true,
          route: '/quality-management/documents'
        },
      ]
    }
  },
];
